import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

// #29/#50/#47 — gate that forces an agent (or a principal acting as their agent)
// to complete their agent profile before reaching the dashboard or any request
// flow. Field-driven: it fires whenever the account acts as an agent AND has any
// required field missing (server-computed agentMissingFields). Other staff and
// complete agents pass straight through. Unauthenticated visitors are handled
// upstream by RequireAuth. The destination is preserved so onboarding returns them.
const RequireOnboarded = ({ children }) => {
  const { user, loading, actingAsAgent, agentInfoComplete } = useAuth();
  const location = useLocation();

  if (loading) {
    return <h3>Loading...</h3>;
  }

  // #57 - a principal driving a flow on behalf of an agent (?agent=<id>) is
  // not gated on their OWN profile; the target agent's completeness is handled
  // inside the on-behalf flow itself.
  const onBehalf =
    user?.role === "agency" && new URLSearchParams(location.search).get("agent");
  if (user && actingAsAgent(user) && !agentInfoComplete(user) && !onBehalf) {
    const dest = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/onboarding?redirect=${dest}`} replace />;
  }

  return children;
};

export default RequireOnboarded;
